import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

/**
 * @typedef {Object} Location
 * @property {string} [pathname]
 * @property {string} [search]
 */

/**
 * ScrollTop component
 *
 * @param {Object} props
 * @param {Location} [props.location]
 * @param {React.ReactNode} [props.children]
 *
 * @returns {JSX.Element}
 */
const ScrollTop = ({ location, children }) => {
  const { pathname, search } = location
  const history = useHistory()

  useEffect(() => {
    // Only scroll to the top if we are on a new page.
    // When pressing the browser back or forward button, allow native scroll restoration to occur.
    // We know back or forward button has been pressed when the `history.action` is a POP.
    // This also works where we have used `history.goBack()` e.g. breadcrumbs.
    if (history.action === 'POP') return
    window.scrollTo(0, 0)
  }, [pathname, search, history.action])

  return <>{children}</>
}

export default ScrollTop
